import { PAGE_MODE } from '../components/pdfViewer/constants';
import { PageModeType } from '../components/pdfViewer/types';

const STORAGE_PREFIX_NORMALIZED_LABELS = 'HAVE-LABELS-BEEN-NORMALIZED-';
const PDF_VIEWER_PREFERENCES = 'PDF-VIEWER-PREFERENCES-';

type PdfPreferencesType = {
    PAGE_MODE: PageModeType;
    THUMBNAIL_PANEL_VISIBLE: boolean;
}

class BrowserStorage {
    static getItem(key: string) {
        return JSON.parse(localStorage.getItem(key) ?? 'null');
    }

    static setItem(key: string, value: string): void {
        localStorage.setItem(key, value);
    }

    static getLabelsNormalizationStatus(extractionId: number) {
        return localStorage.getItem(`${STORAGE_PREFIX_NORMALIZED_LABELS}${extractionId}`) === 'true';
    }

    static setLabelsNormalizationStatus(extractionId: number, status: boolean) {
        localStorage.setItem(`${STORAGE_PREFIX_NORMALIZED_LABELS}${extractionId}`, String(status));
    }

    static deleteLabelsNormalizationStatus(extractionId: number) {
        localStorage.removeItem(`${STORAGE_PREFIX_NORMALIZED_LABELS}${extractionId}`);
    }

    private static getDefaultPdfPreferences() {
        return JSON.stringify({
            PAGE_MODE: PAGE_MODE.SINGLE_PAGE,
            THUMBNAIL_PANEL_VISIBLE: true,
        });
    }

    static getUserPdfViewerPreferences(userId: number): PdfPreferencesType {
        return JSON.parse(
            localStorage.getItem(`${PDF_VIEWER_PREFERENCES}${userId}`) ?? this.getDefaultPdfPreferences()
        );
    }

    static setUserPdfViewerPreferences(userId:number, preferences: PdfPreferencesType) {
        localStorage.setItem(`${PDF_VIEWER_PREFERENCES}${userId}`, JSON.stringify(preferences))
    }
}

export default BrowserStorage;
